/**
 *
 * ForgottenPassword
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

import { FormattedMessage } from "react-intl"
import { Input, Button, message } from "antd"
import { Link } from "react-router-dom"
import { push } from "connected-react-router"
import messages from "./messages"
import "./index.less"
import img from "images/brand/Mandu_white.svg"
import { loadTextsLocalStorage } from "../../utils/i18n"
/* eslint-disable react/prefer-stateless-function */
class ForgottenPasswordForm extends React.Component {
  constructor() {
    super()
    this.state = {
      email: "",
      typing: false,
    }
    this.intl = loadTextsLocalStorage("login")
  }

  handleSubmit = () => {

    if(this.state.email.includes('@yopmail.com')) {
      message.error("Esta funcionalidad no está disponible para este tipo de correos.")
      return
    }

    const payload = { email: this.state.email }
    this.props.onRecover(payload)
  }

  render() {
    return (
      <div className="loginContainer">
        <div className="loginFormPassword">
          <Link to="login" onClick={this.props.onReset}>
            <img src={img} />
          </Link>
          <span style={{ placeSelf: "center", fontWeight: 600 }}>
            {this.intl.forgotPasswordForm.title}
          </span>
          <span style={{ placeSelf: "center" }}>
          {this.intl.forgotPasswordForm.enterYourEmail}
          </span>
          <Input
            id="email"
            placeholder={this.intl.forgotPasswordForm.email}
            name="email"
            onPressEnter={this.handleSubmit}
            onChange={(e) => {
              this.props.onReset()
              this.setState(
                {
                  email: e.target.value,
                  typing: true,
                },
                () => {
                  this.setState({ typing: false })
                }
              )
            }}
          />
          <div className="buttonsContainer">
            <Button
              className="buttonFirst"
              size="large"
              onClick={this.props.onReset}>
              <Link to="/login">{this.intl.forgotPasswordForm.cancel}</Link>
            </Button>
            <Button
              className="buttonEnd"
              type="submit"
              onClick={this.handleSubmit}
              size="large"
              loading={this.props.loading}>
              {this.intl.forgotPasswordForm.accept}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

ForgottenPasswordForm.propTypes = {}

export default ForgottenPasswordForm
